// extracted by mini-css-extract-plugin
export default {"write":"InquiryWrite_write__nxxbr","selectStarRegist":"InquiryWrite_selectStarRegist__hiYy1"};